module.exports = __webpack_public_path__ + "img/11.05ea210a.png";